import { CognitiveJourneyStatus } from './constants';

export const getJourneyStatusByLabel = (label) =>
  Object.values(CognitiveJourneyStatus).find((cjs) => cjs.label === label);
